import { Component } from '@angular/core';

@Component({
  selector: 'app-viewer-right-panel',
  templateUrl: 'viewer-right-panel.component.html',
  styleUrls: ['viewer-right-panel.component.scss'],
})
export class ViewerRightPanelComponent {
  constructor() {}
}
